import { Component, OnInit, Input } from '@angular/core';
import { CarDetail } from '../../shared/car-detail';
import { MileageTypePipe } from '../mileage-type.pipe';
import { CurrencyPipe } from '@angular/common';

@Component({
  standalone: false,
  selector: 'car-options',
  templateUrl: './car-options.component.html',
  providers: [MileageTypePipe, CurrencyPipe]
})
export class CarOptionsComponent implements OnInit {

  @Input()
  public options: CarDetail;
  public optionsInternal: any[];

  constructor(
    private mileageTypePipe: MileageTypePipe,
    private currencyPipe: CurrencyPipe) { }

  ngOnInit() {
    if (!this.options) {
      return;
    }
    this.optionsInternal = [];
    if (this.options.isAutomaticTransmission) {
      this.optionsInternal.push({
        name: 'car.carOptions.automaticTransmission'
      });
    } else {
      this.optionsInternal.push({
        name: 'car.carOptions.manualTransmission'
      });
    }
    if (this.options.isUnlimitedMileage) {
      this.optionsInternal.push({
        name: 'car.common.mileage.unlimitedMileage'
      });
    }
    if (!this.options.isUnlimitedMileage
      && this.options.mileage) {

        const currencySymbol = this.currencyPipe.transform(
        0, this.options.mileage.currencyCode, 'symbol', '1.0-0'
      ).slice(0, -1);
      const paramsValues = {
        allowance: this.options.mileage.allowance,
        unitOfMeasure: this.options.mileage.unitOfMeasure,
        rateType: this.options.mileage.rateType,
        extraMileageCharge: currencySymbol + this.options.mileage.extraMileageCharge
      };

      this.optionsInternal.push({
        name: 'car.common.mileage.limitedMileage',
        extra: 'car.common.mileage.limitedMileageExtra',
        params: paramsValues,
      });
    }
    if (this.options.isFreeCancellation) {
      this.optionsInternal.push({
        name: 'car.carOptions.freeCancelation'
      });
    }
    // if (this.options.isAirConditioning) {
    //   this.optionsInternal.push({
    //    name: 'car.carOptions.airConditioning'
    //   });
    // }
    if (this.options.isAirBags) {
      this.optionsInternal.push({
        name: 'car.carOptions.airBags'
      });
    }
  }
}
